import { useState } from "react";

interface Props {
    onSearch: (clinicName: string) => void;
    isSearching: boolean;
    defaultValue?: string;
}

export default function ClinicNameStep({ onSearch, isSearching, defaultValue = "" }: Props) {
    const [clinicName, setClinicName] = useState(defaultValue);

    const handleSubmit = () => {
        if (clinicName.trim() && !isSearching) onSearch(clinicName.trim());
    };

    return (
        <div className="flex w-full max-w-[520px] flex-col items-center gap-8">
            <h1 className="fraunces-soft text-4xl font-semibold leading-tight text-shadow-700">
                What's your clinic called?
            </h1>
            <p className="text-lg text-shadow-500">I'll find it so you don't have to type your address</p>

            <input
                type="text"
                value={clinicName}
                onChange={(e) => setClinicName(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                placeholder="Valley Veterinary Clinic"
                // eslint-disable-next-line jsx-a11y/no-autofocus -- sole input of this onboarding wizard step; autofocus is intentional UX
                autoFocus
                className="w-full rounded-xl border border-shadow-100 bg-white px-4 py-3.5 text-left text-lg text-shadow-700 placeholder:text-shadow-200 focused-inset"
            />

            <button
                onClick={handleSubmit}
                disabled={!clinicName.trim() || isSearching}
                className="w-full rounded-xl bg-max-900 py-3.5 text-lg font-semibold text-white hover:bg-max-850 disabled:bg-gray-100 disabled:text-gray-400 focused"
            >
                {isSearching ? (
                    <span className="flex items-center gap-2">
                        <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/30 border-t-white" />
                        Searching...
                    </span>
                ) : (
                    "Search"
                )}
            </button>

            <p className="text-sm text-shadow-400">
                Press{" "}
                <kbd className="rounded border border-shadow-100 bg-shadow-25 px-1.5 py-0.5 font-mono text-xs">
                    Enter ↵
                </kbd>
            </p>
        </div>
    );
}
